"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

var _index2 = require("../../../../utils/index");

var _cta_helpers = require("../cta_helpers.js");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _button_styles = _interopRequireDefault(require("./button_styles"));

var _button_definition = _interopRequireDefault(require("./button_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// helpers
// styles
// definition

/* ========== ~~~~~~~~~~ BUTTON ~~~~~~~~~~ ========== */


var Button = (0, _reactJss.default)(_button_styles.default)(function (props) {
  return _react.default.createElement("button", {
    className: "cta button ".concat((0, _index2.generateClasses)(props, ['iconRight']), " ").concat(props.classes.button, " ").concat(props.klass, " processing-").concat(props.processing),
    disabled: !!props.disabled,
    onClick: function onClick(e) {
      return (0, _cta_helpers.handleClick)(props, e);
    }
  }, (0, _cta_helpers.handleIcon)(props), _react.default.createElement("span", {
    className: "text"
  }, (0, _cta_helpers.handleText)(props.processing, props.operation, props.text)), props.badge ? _react.default.createElement(_index.Badge, {
    type: props.badge
  }) : null);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Button, _button_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Button;
exports.default = _default;